import React, { useState } from 'react';
import PieChart from './PieChart';
import { FiChevronDown } from 'react-icons/fi';

export default function PieChartWidget({ data = [], currentLevel, setSelectedGre, setSelectedSchool, selectedGre, selectedSchool }) {
  const [sortDirection, setSortDirection] = useState('desc');

  const sorted = [...data].sort((a, b) => {
    if (sortDirection === 'asc') {
      return a['chart_percentage'] - b['chart_percentage'];
    } else {
      return b['chart_percentage'] - a['chart_percentage'];
    }
  });

  return (
    <div className="report-widget">
      <div className="report-widget__header">
        <div className="report-widget__inner">
          <h3 className="report-widget__title">Desempenho por GRE</h3>
        </div>
        <button
          className="btn btn--outline"
          disabled={data.length === 0}
          onClick={() => setSortDirection(sortDirection === 'desc' ? 'asc' : 'desc')}
        >
          {' '}
          <FiChevronDown
            className="h-6 w-6"
            style={{ transform: sortDirection === 'desc' ? 'rotate(0deg)' : 'rotate(180deg)' }}
          />
          Ordenar pelo {sortDirection === 'desc' ? 'menor' : 'maior'}
        </button>
      </div>
      {selectedGre && (
        <div className="mb-6 flex gap-2 border-b border-neutral-lightest pb-3">
          <span className="text-neutral-light">GREs</span>
          <span
            onClick={() => {
              setSelectedGre(null);
              setSelectedSchool(null);
            }}
            className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer"
          >
            <FiChevronDown
              style={{ transform: 'rotate(90deg)' }}
              className="card__icon"
            />
          </span>
          <span className="font-semibold text-primary-dark">{selectedGre?.['regional_name']}</span>
          {selectedSchool && (
            <>
              <span
                onClick={() => {
                  setSelectedSchool(null);
                }}
                className="card__icon-wrapper card__icon-wrapper--sm u-cursor-pointer"
              >
                <FiChevronDown
                  style={{ transform: 'rotate(90deg)' }}
                  className="card__icon"
                />
              </span>
              <span className="font-semibold text-primary-dark">{selectedSchool?.['institution_name']}</span>
            </>
          )}
        </div>
      )}

      <div className="report-widget__body">
        <PieChart
          data={sorted}
          currentLevel={currentLevel}
          setSelectedGre={setSelectedGre}
          setSelectedSchool={setSelectedSchool}
        />
      </div>
    </div>
  );
}
